import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Form from 'components/common/Form';
import { Button, Checkbox, Input } from 'components/common';
import { createLanguage, getAdminLanguageById as getLanguageById, updateLanguage } from 'apis/adminLanguages';
import { ImageUploadField, useToast } from 'components/admin';
import { useAdminCreateMutation, useAdminDetailQuery, useAdminUpdateMutation } from 'hooks';
import styles from './Languages.module.scss';

const LanguagesForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const toast = useToast();
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        isActive: true,
        isDefault: false,
        sortOrder: 0,
        flagImage: '',
    });
    const [errors, setErrors] = useState({});
    const { data: detail, error: detailError } = useAdminDetailQuery('languages', id, getLanguageById);
    const createMutation = useAdminCreateMutation('languages', createLanguage);
    const updateMutation = useAdminUpdateMutation('languages', updateLanguage);
    const loading = createMutation.isPending || updateMutation.isPending;

    useEffect(() => {
        if (detail) setFormData(detail);
    }, [detail]);

    useEffect(() => {
        if (detailError) toast.error(detailError.message);
    }, [detailError, toast]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = id
                ? await updateMutation.mutateAsync({ id, data: formData })
                : await createMutation.mutateAsync(formData);
            if (res.success) {
                toast.success(id ? 'Cập nhật thành công' : 'Thêm mới thành công');
                navigate('/admin/languages');
            } else {
                if (res.messageError) setErrors(res.messageError);
                else toast.error(res.message);
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    return (
        <div className={styles.formContainer}>
            <h1>{id ? 'Cập nhật Ngôn ngữ' : 'Thêm Ngôn ngữ'}</h1>
            <Form onSubmit={handleSubmit}>
                <Input label="Tên ngôn ngữ" name="name" value={formData.name} onChange={handleChange} required error={errors.name} />
                <Input label="Mã (Code)" name="code" value={formData.code} onChange={handleChange} required error={errors.code} />
                <ImageUploadField
                    label="Hình cờ (Flag Image)"
                    value={formData.flagImage}
                    folder="languages"
                    onChange={(flagImage) => setFormData(prev => ({ ...prev, flagImage }))}
                />
                <Input label="Thứ tự" name="sortOrder" type="number" value={formData.sortOrder} onChange={handleChange} />
                <Checkbox label="Hoạt động" name="isActive" checked={formData.isActive} onChange={handleChange} />
                <Checkbox label="Mặc định" name="isDefault" checked={formData.isDefault} onChange={handleChange} />
                <div className={styles.actions}>
                    <Button type="submit" disabled={loading}>{loading ? 'Đang lưu...' : 'Lưu'}</Button>
                    <Button type="button" variant="secondary" onClick={() => navigate('/admin/languages')}>Hủy</Button>
                </div>
            </Form>
        </div>
    );
};

export default LanguagesForm;
